import ApiTxItem from '@/api/ApiTxItem'

export default {
    cancel (id) {
        return ApiTxItem.cancel(id)
    },
}
